import { RESET_SEARCH_OBJ } from "../action.js";

export const resetSearchObj = (initialSearchObj) => {
  return (dispatch) => {
    dispatch({ type: RESET_SEARCH_OBJ, payload: initialSearchObj });
  };
};
